/* eslint-disable unicorn/no-null, no-restricted-exports, unicorn/no-anonymous-default-export, func-style */
const hasChanges = ref<boolean>(false);
const resetFunction = ref<(() => void) | null>(null);
const saveFunction = ref<(() => Promise<void>) | null>(null);
const isModalOpen = ref(false);
const isLoading = ref(false);

const modalClosePromise = ref(Promise.resolve());
const modalClosePromiseResolve = ref(() => {
    return;
});
watchEffect(() => {
    if (isModalOpen.value) {
        modalClosePromise.value = new Promise((resolve) => {
            modalClosePromiseResolve.value = resolve;
        });

        return;
    }

    modalClosePromiseResolve.value();
});

export default () => {
    function setHasChanges(hasNewChanges: boolean) {
        hasChanges.value = hasNewChanges;
    }

    function setSaveFunction(function_: () => Promise<void>) {
        saveFunction.value = function_;
    }

    function setResetFunction(function_: () => void) {
        resetFunction.value = function_;
    }

    function setUnsavedChangesHeader(
        hasNewChanges: boolean,
        resetFunction_: (() => void) | undefined,
        saveFunction_: (() => Promise<void>) | undefined,
    ) {
        setHasChanges(hasNewChanges);

        if (resetFunction_) setResetFunction(resetFunction_);
        if (saveFunction_) setSaveFunction(saveFunction_);
    }

    function setIsLoading(isNewLoading: boolean) {
        isLoading.value = isNewLoading;
    }

    const toggleModal = (isOpen: boolean) => {
        isModalOpen.value = isOpen;
    };

    return {
        hasChanges,
        isLoading,
        isModalOpen,
        modalClosePromise,
        resetFn: resetFunction,
        saveFn: saveFunction,
        setIsLoading,
        setUnsavedChangesHeader,
        toggleModal,
    };
};
